import PayFrequencyInfo from "@/model/apply/PayFrequencyInfo"

const PayFrequencies = {
    weekly: new PayFrequencyInfo({
        label: "Weekly",
        labelAlternate:"Every Week"
    }),
    bi_weekly: new PayFrequencyInfo({
        label: "Bi-Weekly",
        labelAlternate:"Every Other Week"
    }),
    monthly: new PayFrequencyInfo({
        label: "Monthly",
        labelAlternate:"Every Month"
    }),
    semi_monthly: new PayFrequencyInfo({
        label: "Twice Monthly",
        labelAlternate:"Twice A Month"
    }),
}

export const PayFrequency = {
    WEEKLY: "weekly",
    BI_WEEKLY: "bi_weekly",
    SEMI_MONTHLY: "semi_monthly",
    MONTHLY: "monthly",
}

export default PayFrequencies
